import CustomContent from "@arcgis/core/popup/content/CustomContent.js";
import Point from "@arcgis/core/geometry/Point.js";
import texts from "../../../../assets/texts/texts";


export default class PopUp {
  constructor(view, graphic, title) {
    if (view) {
      this.view = view;
      this.graphic = graphic;
      this.popUPContent = null;

      this.popUpTemplate();
      this.setPopUpValue();
      this.title = title;
    }
  }

  popUpTemplate() {

    let customContentWidget = new CustomContent({
      outFields: ["*"],
      creator: () => {
        return `${texts.widgets.uploadmodel.upload.popup.description} <a href=${texts.instuction.url} target="_blank">${texts.instuction.title}</a>`;
      },
    });

    this.popUPContent = {
      title: "{name}",
      content: [
        customContentWidget,
        {
          // Pass in the fields to display
          type: "fields",
          fieldInfos: [
            {
              fieldName: "latitude",
              label: texts.widgets.uploadmodel.upload.popup.lattitude,
            },
            {
              fieldName: "longitude",
              label: texts.widgets.uploadmodel.upload.popup.longtitude,
            },
            {
              fieldName: "zGraund",
              label: texts.widgets.uploadmodel.upload.popup.terain,
            },
            {
              fieldName: "z",
              label: texts.widgets.uploadmodel.upload.popup.refencpoint,
            },
            {
              fieldName: "height",
              label: texts.widgets.uploadmodel.upload.popup.hight,
            },
            {
              fieldName: "heightUnderGround",
              label:texts.widgets.uploadmodel.upload.popup.belowterrain,
            },
            {
              fieldName: "heightAboveGround",
              label: texts.widgets.uploadmodel.upload.popup.aboveterrain,
            },
          ],
        },
      ],
    };
  }

  setPopUpValue() {
    const point = new Point({
      x: this.graphic.geometry.origin.x,
      y: this.graphic.geometry.origin.y,
      spatialReference: this.graphic.geometry.spatialReference,
    });

    const longitudeValues = this.convertDecimalToDMS(
      this.graphic.geometry.origin.longitude
    );
    const latitudeValues = this.convertDecimalToDMS(
      this.graphic.geometry.origin.latitude
    );

    const longtitudeString =
      longitudeValues.degrees +
      "° " +
      longitudeValues.minutes +
      "' " +
      longitudeValues.seconds +
      "' ";
    const latitudeString =
      latitudeValues.degrees +
      "° " +
      latitudeValues.minutes +
      "' " +
      latitudeValues.seconds +
      "' ";

   
    this.view.map.ground.queryElevation(point).then((result) => {

      const aboveGround =  (Math.round(
            (Number(this.graphic.geometry.extent.zmax) -
              Number(result.geometry.z)) *
              100
          ) /
            100)

      const underGround =    Math.round(
            (Number(result.geometry.z) -
              Number(this.graphic.geometry.extent.zmin)) *
              100
          ) /
            100

      const checkAboveGround = aboveGround > 0 ? aboveGround : 0;
      const checkUnderGround = underGround > 0 ? underGround : 0;
      this.graphic.attributes = {
        name: this.title,
        longitude: longtitudeString,
        latitude: latitudeString,
        z:
          Math.round(Number(this.graphic.geometry.origin.z) * 100) / 100 +
          " m n. m.",
        zGraund: Math.round(Number(result.geometry.z) * 100) / 100 + " m n. m.",
        height:
          Math.round(
            (Number(this.graphic.geometry.extent.zmax) -
              Number(this.graphic.geometry.extent.zmin)) *
              100
          ) /
            100 +
          " m",
        heightUnderGround:
          checkUnderGround +
          " m",
        heightAboveGround:
       checkAboveGround +

          " m",
      };

      this.graphic.popupTemplate = this.popUPContent;
    });
  }
  convertDecimalToDMS(decimalDegrees) {
    // Ensure the input is a positive number for calculations
    const absDecimalDegrees = Math.abs(decimalDegrees);

    // Get the whole number part for degrees
    const degrees = Math.floor(absDecimalDegrees);

    // Get the fractional part and convert to minutes
    const minutesDecimal = (absDecimalDegrees - degrees) * 60;
    const minutes = Math.floor(minutesDecimal);

    // Get the fractional part of minutes and convert to seconds
    const seconds = Math.round((minutesDecimal - minutes) * 60);

    // Determine the direction (N, S, E, W)
    const direction =
      decimalDegrees < 0
        ? decimalDegrees === -absDecimalDegrees
          ? "S"
          : "W"
        : decimalDegrees === 0
        ? "N/A"
        : "N"; // For simplicity, assuming no longitude input yet

    return {
      degrees: degrees,
      minutes: minutes,
      seconds: seconds,
      direction: direction,
    };
  }
}
